import React from "react";
import classnames from "classnames";
import { IColPartProps } from "../../models";
import { colWidthToDeviceClass } from "../../models/utils";
import css from "../../form.module.scss";



const ColPart = ({mobileWidth, tabletWidth, desktopWidth, children}: React.PropsWithChildren<IColPartProps>) => {
  const classes = classnames(
    css.formPart,
    'column',
    colWidthToDeviceClass("mobile", mobileWidth),
    colWidthToDeviceClass("tablet", tabletWidth),
    colWidthToDeviceClass("desktop", desktopWidth)
  );

  return (
    <div className={classes}>
      {children}
    </div>
  );
}

export default ColPart;
